import React, { lazy, Suspense } from 'react';
import { renderIntoContainer, unmountContainer } from 'react/root/containerRoot';

const ConnectionTypePrompt = lazy(() => import(/* webpackChunkName: "ConnectionTypePrompt" */ 'react/matchmaking/connection/ConnectionTypePrompt'));

// matchmaking/start refuses a player who hasn't said whether they play wired
// or on wifi with error_data.needs_connection_type.
export const needsConnectionType = (response) => Boolean(response && response.error_data && response.error_data.needs_connection_type);

let pendingQuestion = null;

/**
 * Shows ConnectionTypePrompt over the page. Resolves with the saved
 * connection type, or null when the player closes it. Searches refused for
 * several games at once share one prompt.
 */
export default function askForConnectionType() {
	if(pendingQuestion) {
		return pendingQuestion;
	}
	pendingQuestion = new Promise((resolve) => {
		const container = document.createElement('div');
		document.body.appendChild(container);
		const finish = (connectionType) => {
			unmountContainer(container);
			container.remove();
			pendingQuestion = null;
			resolve(connectionType);
		};
		renderIntoContainer(
			<Suspense fallback={null}>
				<ConnectionTypePrompt onSaved={finish} onClose={() => finish(null)} />
			</Suspense>,
			container,
			{ sync: false }
		);
	});
	return pendingQuestion;
}
